import { axiosInstance } from "./api_instance";

export default async function fetchAllQuiz() {

    try {
        const response = await axiosInstance.get(`/quiz`)
        if(response.status === 200){
            return response.data.success
        }

    } catch (error) {
        let msg = await error.response.data.error.message
      
        return msg
    }
} 